export enum LineActions {
  CAMBIO_MENU = 'CAMBIO_MENU',
  GROUP_ALEATORIO = 'GRUPOS_ALEATORIO',
}
